module.exports = __webpack_public_path__ + "static/media/audioml_thumb.68d8dcc0.jpg";